import { render, staticRenderFns } from "./SocialCounter.vue?vue&type=template&id=045527c6&scoped=true&"
import script from "./SocialCounter.vue?vue&type=script&lang=js&"
export * from "./SocialCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045527c6",
  null
  
)

export default component.exports